class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = !this.summaryToggle || this.summaryToggle.textContent.trim().length === 0;

    // Only proceed if detailsContainer exists
    if (!this.detailsContainer) {
      console.warn('No <details> element found in <footer-accordion>. Skipping initialization.');
      return;
    }

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    }

    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));

    if (!theme.config.mqlSmall || this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('open', true);

      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    } else {
      if (this.dataset.open === undefined) {
        this.detailsContainer.removeAttribute('open');
      }
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    if (details && details.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (this.detailsContainer) {
      this.detailsContainer.setAttribute('open', true);
    }
  }

  close() {
    if (theme.config.mqlSmall && !this.summaryIsEmpty && this.detailsContainer) {
      this.detailsContainer.removeAttribute('open');
    }
  }
}

customElements.define('footer-accordion', FooterAccordion);
